import React, { Component, createRef } from "react";
import axios from "../../utils/axiosInstance";
import "./ChatDashboardHost.css";

class ChatDashboardHost extends Component {
  constructor(props) {
    super(props);

    this.state = {
      conversations: [],
      activeChatId: null,
      messages: [],
      customer_id: "",
      booking_id: "",
      inputText: "",
      isLoading: true,
      isSending: false,
      loadingMessages: false,
      isDemo: false,
      booking_status: "",
      loading: false,
      mobileView: "inbox",

      // Modal States
      showDetailsModal: false,
      showUpdateStatusModal: false,
      showSpecialOfferModal: false,
      showGuestDetailsModal: false,
      offerPrice: "",
    };

    this.chatEndRef = createRef();
  }

  componentDidMount() {
    const web_user_id = localStorage.getItem("web_user_id");
    if (!web_user_id) {
      window.location.href = "/";
      return;
    }
    this.getConversations();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.messages !== this.state.messages) {
      this.scrollToBottom();
    }
  }

  scrollToBottom = () => {
    setTimeout(() => {
      this.chatEndRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }, 50);
  };

  demoConversations = [
    {
      id: 1,
      customer_id: 1,
      booking_id: 101,
      customer_name: "Saymon Islam",
      customer_phone: "+8801713944546",
      customer_email: "saymon@example.com",
      avatar: "https://i.pravatar.cc/150?img=11",
      status: "online",
      last_message: "Hello",
      date: "31 Jul - 01 Aug",
      check_in: "31 Jul, 2026",
      check_out: "01 Aug, 2026",
      reviewNeeded: false,
      title: "Comfortable Private AC Bedroom with Attached Washroom & Balcony",
      location: "Mohammadpur | Bosila City Housing",
      feature_image: "",
      gallery_images: "[]",
      total_nights: 1,
      adults: 2,
      baths: 1,
      per_day_amount: 1499,
      total: 1499,
      booking_status: "Pending",
    },
    {
      id: 2,
      customer_id: 2,
      booking_id: 102,
      customer_name: "Hamim Ahmed",
      customer_phone: "+8801747050684",
      customer_email: "hamim@example.com",
      avatar: "https://i.pravatar.cc/150?img=5",
      status: "online",
      last_message: "Is it safe?",
      date: "26 Aug - 27 Aug",
      check_in: "26 Aug, 2026",
      check_out: "27 Aug, 2026",
      reviewNeeded: true,
      title: "Private AC Room",
      location: "Gulshan 1 | Dhaka",
      feature_image: "",
      gallery_images: "[]",
      total_nights: 1,
      adults: 1,
      baths: 1,
      per_day_amount: 1699,
      total: 1699,
      booking_status: "Confirmed",
    },
  ];

  demoMessages = [
    {
      id: 1,
      sender: "user",
      message: "Hi, I would like to confirm my check-in time.",
      time: "08:50 PM",
    },
  ];

  getConversations = async () => {
    try {
      const web_user_id = localStorage.getItem("web_user_id");
      const res = await axios.get(`/chat/host_conversations/${web_user_id}`);
      const conversations = res.data?.data || [];

      if (!conversations.length) throw new Error("Empty");

      this.setState(
        {
          conversations,
          activeChatId: conversations[0].id,
          customer_id: conversations[0].customer_id,
          booking_id: conversations[0].booking_id,
          booking_status: conversations[0].booking_status || "",
          isLoading: false,
          isDemo: false,
        },
        () => this.getMessages(conversations[0].id)
      );
    } catch (error) {
      console.warn("Demo mode enabled");
      this.setState(
        {
          conversations: this.demoConversations,
          activeChatId: this.demoConversations[0].id,
          customer_id: this.demoConversations[0].customer_id,
          booking_id: this.demoConversations[0].booking_id,
          booking_status: this.demoConversations[0].booking_status,
          isLoading: false,
          isDemo: true,
        },
        () => this.getMessages(this.demoConversations[0].id)
      );
    }
  };

  getMessages = async (chatId) => {
    this.setState({ loadingMessages: true });
    try {
      const web_user_id = localStorage.getItem("web_user_id");
      const res = await axios.get(`/chat/host_messages/${web_user_id}/${chatId}`);
      if (!res.data?.data?.length) throw new Error("Empty");

      this.setState({
        messages: res.data.data,
        loadingMessages: false,
      });
    } catch {
      this.setState({
        messages: this.demoMessages,
        loadingMessages: false,
      });
    }
  };

  sendMessage = async (e) => {
    if (e) e.preventDefault();
    const { customer_id, inputText, messages, isDemo } = this.state;
    const messageText = inputText.trim();
    if (!messageText) return;

    const newMsg = {
      id: Date.now(),
      sender: "partner",
      customer_id,
      message: messageText,
      time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    };

    this.setState({
      messages: [...messages, newMsg],
      inputText: "",
      isSending: true,
    });

    if (isDemo) {
      setTimeout(() => {
        this.setState((prev) => ({
          messages: [
            ...prev.messages,
            {
              id: Date.now(),
              sender: "user",
              message: "Thanks! We will review your request shortly.",
              time: "Just now",
            },
          ],
          isSending: false,
        }));
      }, 1000);
      return;
    }

    try {
      const web_user_id = localStorage.getItem("web_user_id");
      await axios.post("/chat/host_send", {
        host_id: web_user_id,
        customer_id,
        message: messageText,
      });
      this.setState({ isSending: false });
    } catch (error) {
      console.error(error);
      this.setState({ isSending: false });
    }
  };

  handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      this.sendMessage();
    }
  };

  handleChatChange = (chatId) => {
    const selectedChat = this.state.conversations.find((chat) => chat.id === chatId);
    this.setState(
      {
        activeChatId: chatId,
        messages: [],
        customer_id: selectedChat?.customer_id || "",
        booking_id: selectedChat?.booking_id || "",
        booking_status: selectedChat?.booking_status || "",
        mobileView: "chat",
      },
      () => this.getMessages(chatId)
    );
  };

  handleMobileBack = () => {
    this.setState({ mobileView: "inbox" });
  };

  handleApproval = async () => {
    const { booking_id, activeChatId, conversations } = this.state;
    if (!booking_id) return;

    this.setState({ loading: true });
    try {
      const response = await axios.post("/chat/host_approval", { id: booking_id });
      if (response.data.status === "success" || this.state.isDemo) {
        const updatedConversations = conversations.map((chat) => {
          if (chat.id === activeChatId) return { ...chat, booking_status: "Confirmed" };
          return chat;
        });
        this.setState({
          booking_status: "Confirmed",
          conversations: updatedConversations,
          loading: false,
        });
      } else {
        this.setState({ loading: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ loading: false });
    }
  };

  handleSpecialOfferSubmit = async () => {
    const { booking_id, offerPrice, activeChatId, conversations } = this.state;

    if (!offerPrice || !booking_id) return;

    try {
      const response = await axios.post(
        "/special_offer_price",
        {
          booking_id: booking_id,
          total_amount: offerPrice,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === "success") {
        const updatedConversations = conversations.map((chat) => {
          if (chat.id === activeChatId) {
            return {
              ...chat,
              total: response.data.booking.total_amount,
            };
          }
          return chat;
        });

        this.setState({
          conversations: updatedConversations,
          showSpecialOfferModal: false,
          offerPrice: "",
        });
      }
    } catch (error) {
      console.error("Error updating special offer:", error);
    }
  };

  getBaseUrl = () => {
    return axios.defaults.baseURL ? axios.defaults.baseURL.replace("/api", "") : "";
  };

  renderIcon = (type) => {
    const icons = {
      back: <svg viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6" /></svg>,
      send: <svg viewBox="0 0 24 24"><path d="M22 2 11 13" /><path d="m22 2-7 20-4-9-9-4Z" /></svg>,
      link: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
          <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
        </svg>
      ),
      userOutline: (
        <svg viewBox="0 0 24 24">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      ),
      phone: (
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M21.384 17.752a2.108 2.108 0 0 1-.522 2.712c-1.565 1.155-3.419 1.693-5.32 1.488-3.435-.365-6.6-2.14-8.86-5.006-2.18-2.76-3.32-6.136-3.218-9.52.029-1.92.74-3.722 2.016-5.12a2.094 2.094 0 0 1 2.85-.306l3.411 2.6c.725.553.978 1.543.593 2.348l-1.282 2.68c-.287.6-.201 1.309.22 1.838 1.053 1.326 2.38 2.403 3.868 3.141.597.296 1.312.22 1.848-.198l2.584-2.01c.783-.61 1.916-.543 2.617.155l3.197 3.198Z" />
        </svg>
      ),
    };
    return icons[type] || null;
  };

  renderConversationList = () => {
    const { conversations, activeChatId, isLoading } = this.state;

    if (isLoading) {
      return (
        <div className="chat-loading-list">
          {[1, 2, 3, 4].map((item) => (
            <div className="chat-skeleton" key={item}>
              <div className="skeleton-avatar" />
              <div className="skeleton-content">
                <span />
                <span />
                <span />
              </div>
            </div>
          ))}
        </div>
      );
    }

    if (!conversations.length) {
      return (
        <div className="chat-empty">
          <div className="chat-empty-icon">💬</div>
          <h3>No messages yet</h3>
          <p>Customer conversations will appear here.</p>
        </div>
      );
    }

    return conversations.map((chat) => (
      <button
        type="button"
        key={chat.id}
        className={`conversation-item ${activeChatId === chat.id ? "active" : ""}`}
        onClick={() => this.handleChatChange(chat.id)}
      >
        <div className="conversation-avatar">
          <img src={chat.avatar} alt={chat.customer_name || "Customer"} />
          <span className={`online-status ${chat.status === "online" ? "online" : "offline"}`} />
        </div>
        <div className="conversation-content">
          <div className="conversation-top">
            <h3>{chat.customer_name || "Customer"}</h3>
          </div>
          <p className="conversation-message">{chat.last_message || "No messages yet"}</p>
          <div className="conversation-bottom">
            <span className="conversation-booking">{chat.title || "Property booking"}</span>
            {chat.booking_status && (
              <span className={`booking-status-pill ${chat.booking_status.toLowerCase().replace(/\s+/g, "-")}`}>
                {chat.booking_status}
              </span>
            )}
          </div>
        </div>
      </button>
    ));
  };

  renderChatHeader = (activeChat) => {
    return (
      <div className="chat-screen-header">
        <button type="button" className="mobile-back-button" onClick={this.handleMobileBack} aria-label="Back to inbox">
          {this.renderIcon("back")}
        </button>

        <div className="active-user-avatar">
          <img src={activeChat.avatar} alt={activeChat.customer_name || "Customer"} />
          <span className="active-online-dot" />
        </div>
        <div className="active-user-info">
          <h2>{activeChat.customer_name || "Customer"}</h2>
        </div>

        {activeChat.customer_phone && (
          <a href={`tel:${activeChat.customer_phone}`} className="chat-header-call" aria-label="Call Customer">
            {this.renderIcon("phone")}
          </a>
        )}
      </div>
    );
  };

  renderPropertySubHeader = (activeChat) => {
    const baseUrl = this.getBaseUrl();
    const thumbnail = activeChat.feature_image
      ? `${baseUrl}/uploads/posts/${activeChat.feature_image}`
      : "https://via.placeholder.com/60";

    return (
      <div className="mobile-chat-property-header">
        <div className="prop-header-top">
          <img src={thumbnail} alt="Property" className="prop-thumb" />
          <div className="prop-title-wrap">
            <span className="prop-title">{activeChat.title || "Property Details"}</span>
          </div>
          <button
            className="prop-details-btn"
            onClick={() => this.setState({ showDetailsModal: true })}
          >
            Details
          </button>
        </div>
        <div className="prop-header-bottom">
          <span className={`status-text ${activeChat.booking_status?.toLowerCase()}`}>
            {activeChat.booking_status || "Pending"}
          </span>
          <span className="separator">•</span>
          <span>{activeChat.date || "Not set"}</span>
          <span className="separator">•</span>
          <span>{activeChat.adults || 0} Guests</span>
          <span className="separator">•</span>
          <span>{activeChat.total || 0}</span>
        </div>
      </div>
    );
  };

  renderMessages = (activeChat) => {
    const { messages, loadingMessages, isSending } = this.state;

    if (loadingMessages) {
      return (
        <div className="messages-loading">
          <div className="message-loader received-loader">Loading messages...</div>
        </div>
      );
    }

    return (
      <>
        {/* Default Booking Request Banner */}
        <div className="default-request-msg">
          <div className="default-msg-icon">{this.renderIcon("userOutline")}</div>
          <div>
            {activeChat.customer_name} has requested to book <br />
            "{activeChat.title}" <br />
            {activeChat.location && <span>{activeChat.location}</span>}
          </div>
        </div>

        {/* Dynamic Standard Messages */}
        {messages.map((msg) => (
          <div key={msg.id} className={`message-row ${msg.sender === "partner" ? "sent" : "received"}`}>
            <div className="message-bubble">
              <div className="message-text">{msg.message}</div>
              <div className="message-meta">
                <span>{msg.time}</span>
                {msg.sender === "partner" && <span className="message-check">✓✓</span>}
              </div>
            </div>
          </div>
        ))}

        {/* Confirmed Booking System Message */}
        {activeChat.booking_status === "Confirmed" && activeChat.payment_status === "Paid" && (
          <div className="system-message-wrap">
            <div className="system-message-pill">
              {this.renderIcon("link")}
              Your booking has been confirmed. For details select the 'Call' button above
            </div>
          </div>
        )}

        {isSending && (
          <div className="typing-indicator">
            <span />
            <span />
            <span />
          </div>
        )}
        <div ref={this.chatEndRef} />
      </>
    );
  };

  renderChatInput = () => {
    const { inputText, isSending } = this.state;
    return (
      <div className="chat-input-area">
        <form className="chat-input-wrapper" onSubmit={this.sendMessage}>
          <button type="button" className="input-plus-button" aria-label="Add attachment">+</button>
          <textarea
            className="chat-input"
            placeholder="Write message... (Shift + Enter for new line)"
            value={inputText}
            rows={1}
            onChange={(e) => this.setState({ inputText: e.target.value })}
            onKeyDown={this.handleKeyDown}
            style={{ marginBottom: "10px" }}
          />
          <button type="submit" className="send-message-button" disabled={!inputText.trim() || isSending}>
            {this.renderIcon("send")}
          </button>
        </form>
      </div>
    );
  };

  renderModals = (activeChat) => {
    const {
      showDetailsModal,
      showUpdateStatusModal,
      showSpecialOfferModal,
      showGuestDetailsModal,
      offerPrice,
    } = this.state;

    return (
      <>
        {/* Booking Details Modal */}
        {showDetailsModal && (
          <div className="custom-modal-overlay" onClick={() => this.setState({ showDetailsModal: false })}>
            <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="custom-modal-header">
                <h3>Booking Details</h3>
                <button onClick={() => this.setState({ showDetailsModal: false })}>✕</button>
              </div>
              <div className="custom-modal-body">
                <div className="details-card">
                  <p className="details-title">{activeChat.title}</p>

                  <div className="details-section">
                    <h4>Trip Details</h4>
                    <div className="details-row">
                      <span>Guests</span>
                      <strong>{activeChat.adults} Adults</strong>
                    </div>
                    <div className="details-row">
                      <span>Check In & Out</span>
                      <strong>{activeChat.date || "Not set"}</strong>
                    </div>
                    <div className="details-row">
                      <span>Status</span>
                      <strong>{activeChat.booking_status}</strong>
                    </div>
                    <div className="details-row">
                      <span>Amount</span>
                      <strong>{activeChat.total}</strong>
                    </div>
                  </div>

                  <button
                    className="modal-btn-primary"
                    onClick={() => this.setState({ showDetailsModal: false, showGuestDetailsModal: true })}
                  >
                    Guest Details
                  </button>

                  <div className="details-section mt-15">
                    <h4>Contact Details</h4>
                    <p className="text-muted">Contact Number & Location will be provided once you Confirm & Pay</p>
                  </div>

                  <button
                    className="modal-btn-primary"
                    onClick={() => this.setState({ showDetailsModal: false, showUpdateStatusModal: true })}
                  >
                    UPDATE STATUS
                  </button>
                  <button
                    className="modal-btn-success mt-10"
                    onClick={() => this.setState({ showDetailsModal: false, showSpecialOfferModal: true })}
                  >
                    SPECIAL OFFER
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Guest Details Modal */}
        {showGuestDetailsModal && (
          <div className="custom-modal-overlay" onClick={() => this.setState({ showGuestDetailsModal: false })}>
            <div className="custom-modal-content small-modal" onClick={(e) => e.stopPropagation()}>
              <div className="custom-modal-header">
                <h3>Guest Details</h3>
                <button onClick={() => this.setState({ showGuestDetailsModal: false })}>✕</button>
              </div>
              <div className="custom-modal-body">
                <div className="guest-details-list">
                  <div className="details-row">
                    <span>Name</span>
                    <strong>{activeChat.customer_name || "N/A"}</strong>
                  </div>
                  <div className="details-row">
                    <span>Phone</span>
                    <strong>{activeChat.customer_phone || "N/A"}</strong>
                  </div>
                  <div className="details-row">
                    <span>Email</span>
                    <strong>{activeChat.customer_email || "N/A"}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Update Status Modal */}
        {showUpdateStatusModal && (
          <div className="custom-modal-overlay" onClick={() => this.setState({ showUpdateStatusModal: false })}>
            <div className="custom-modal-content small-modal" onClick={(e) => e.stopPropagation()}>
              <div className="custom-modal-header">
                <h3>Update Status</h3>
                <button onClick={() => this.setState({ showUpdateStatusModal: false })}>✕</button>
              </div>
              <div className="custom-modal-body">
                <p>Are you sure you want to approve and update the status?</p>
                <div className="modal-actions">
                  <button className="modal-btn-secondary" onClick={() => this.setState({ showUpdateStatusModal: false })}>
                    Cancel
                  </button>
                  <button
                    className="modal-btn-primary"
                    onClick={() => {
                      this.handleApproval();
                      this.setState({ showUpdateStatusModal: false });
                    }}
                  >
                    Yes, Confirm
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Special Offer Modal */}
        {showSpecialOfferModal && (
          <div className="custom-modal-overlay" onClick={() => this.setState({ showSpecialOfferModal: false })}>
            <div className="custom-modal-content small-modal" onClick={(e) => e.stopPropagation()}>
              <div className="custom-modal-header">
                <h3>Special Offer</h3>
                <button onClick={() => this.setState({ showSpecialOfferModal: false })}>✕</button>
              </div>
              <div className="custom-modal-body">
                <div className="offer-summary-card">
                  <p><strong>Property:</strong> {activeChat.title || "N/A"}</p>
                  <p><strong>Guests:</strong> {activeChat.adults || 0} Guests</p>
                  <p><strong>Current Total:</strong> {activeChat.total || 0}</p>
                </div>

                <label className="modal-label">Enter New Offer Price:</label>
                <input
                  type="number"
                  className="modal-input"
                  placeholder="Enter special total price"
                  value={offerPrice}
                  onChange={(e) => this.setState({ offerPrice: e.target.value })}
                />
                <button
                  className="modal-btn-success mt-15"
                  onClick={this.handleSpecialOfferSubmit}
                  disabled={!offerPrice}
                >
                  Send Offer
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  render() {
    const { conversations, activeChatId, mobileView } = this.state;
    const activeChat = conversations.find((chat) => chat.id === activeChatId) || {};

    return (
      <div className="chat-dashboard">
        {/* DESKTOP */}
        <div className="chat-desktop-layout">
          <aside className="inbox-sidebar">
            <div className="inbox-header">
              <div>
                <span className="page-eyebrow">MESSAGES</span>
                <h1>Inbox</h1>
              </div>
              <div className="inbox-count">{conversations.length}</div>
            </div>
            <div className="conversation-list">{this.renderConversationList()}</div>
          </aside>

          <main className="chat-main-panel">
            {this.renderChatHeader(activeChat)}
            <div className="messages-area">
              {this.renderPropertySubHeader(activeChat)}
              {this.renderMessages(activeChat)}
            </div>
            {this.renderChatInput()}
          </main>
        </div>

        {/* MOBILE */}
        <div className="chat-mobile-layout">
          {mobileView === "inbox" ? (
            <div className="mobile-inbox-screen">
              <div className="mobile-inbox-header">
                <div>
                  <span className="page-eyebrow">MESSAGES</span>
                  <h1>Inbox</h1>
                </div>
                {conversations.length > 0 && <div className="mobile-inbox-count">{conversations.length}</div>}
              </div>
              <div className="mobile-conversation-list">{this.renderConversationList()}</div>
            </div>
          ) : (
            <div className="mobile-chat-screen">
              {this.renderChatHeader(activeChat)}
              {this.renderPropertySubHeader(activeChat)}
              <div className="mobile-messages-area">{this.renderMessages(activeChat)}</div>
              {this.renderChatInput()}
            </div>
          )}
        </div>

        {this.renderModals(activeChat)}
      </div>
    );
  }
}

export default ChatDashboardHost;
